import jwt from "jwt-decode";
import Constants, { NotificationType } from "./Constants";
import Storage from "./storage/StorageFunctions";
import { Logger } from "./HelperFunctions";
import { store } from "../store/Store";
import { updateUser } from "../store/slices/UserSlice";
import { setCurrentPolicyNumber } from "../store/slices/PolicySlice";
import { Linking, Platform } from "react-native";
import Crashlytics from "./crashlyticsUtils/CrashlyticsUtils";
import { messages, urls } from "../../src/resources/strings";
import { getDeviceTokenForNotification } from "./notificationHelper/NotificationManager";
import {
  getUserDetailsFromId,
  registerUser,
  registerDeviceToken,
} from "../api/user";

// Save user profile after getting it from Exzeo ID api
export const saveUserProfile = async (userToken: string) => {
  if (typeof userToken !== "undefined") {
    let decoded: any = jwt(userToken.split(" ")[1]);
    const object: any = await getUserDetailsFromId(decoded.sub);
    if (object.errorCode === messages.error.noError && object.response?.user) {
      store.dispatch(updateUser(object.response.user));

      Crashlytics.signIn(
        object?.response?.user?.id.toString() ?? "",
        object?.response?.user?.email[0]?.email.toString() ?? "",
        object?.response?.user?.username.toString() ?? "",
      );
    }
  }
};

// Get email id from user details
export const getEmailFromUserDetails = async () => {
  const user = store.getState().userReducer;
  if (user?.email != null && user?.email.length > 0) {
    return user.email[0].email ?? "";
  }
  return "";
};

// save|register user in Nexus environment after login from ExzeoID
export const saveUserInNexus = async (userToken: string) => {
  let email = await getEmailFromUserDetails();
  if (typeof email === "undefined" && typeof userToken !== "undefined") {
    let decoded: any = jwt(userToken.split(" ")[1]);
    email = decoded.username;
  }
  await registerUser(email);
  Logger("Register user response");
};

// Upload device token to notification server
export const uploadDeviceToken = async (userToken: string) => {
  let email = await getEmailFromUserDetails();
  if (typeof email === "undefined" && typeof userToken !== "undefined") {
    let decoded: any = jwt(userToken.split(" ")[1]);
    email = decoded.username;
  }

  const deviceToken = await getDeviceTokenForNotification();
  const deviceTokenUserId = await Storage.getData(
    Constants.LocalStoreConstant.DEVICE_TOKEN_USER_ID,
  );

  if (userToken && email) {
    let response = await registerDeviceToken(
      email,
      deviceToken,
      deviceTokenUserId,
    );
    Logger("Register device token response" + JSON.stringify(response));
  }
};

export const getPolicyNumber = async () => {
  const policyId = store.getState().policyReducer.policyNumber;

  if (policyId) {
    return policyId;
  } else {
    const selectedPolicyNumberLocalStore = await Storage.getData(
      Constants.LocalStoreConstant.SELECTED_POLICY_NUMBER,
    );
    store.dispatch(setCurrentPolicyNumber(selectedPolicyNumberLocalStore));
    return selectedPolicyNumberLocalStore;
  }
};

export const findUsMapURL = (physicalAddress: string) => {
  if (Platform.OS == "web") {
    let url = `${urls.mapURL}${physicalAddress}`;
    window.open(url);
  } else {
    const mapURL = Platform.select({
      ios: `maps:0,0?q=${physicalAddress}`,
      android: `geo:0,0?q=${physicalAddress}`,
    });
    Linking.openURL(mapURL ?? "");
  }
};

export const checkValidationForArray = (array: any) => {
  return !!(array && Object.keys(array));
};

export function changeFavicon(src: string) {
  let link = document.querySelector(
    "link[rel~='icon']",
  ) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = src;
}

let controller: AbortController | null = null;

export function createApiController() {
  controller = new AbortController();
  return controller;
}

export function getApiController() {
  return controller;
}

export function abortApiCall() {
  if (controller) {
    controller.abort();
    controller = null;
  }
}
